import React, { useEffect, useContext, useState } from 'react';
import { Route, Switch, useLocation, useHistory } from 'react-router-dom';
import { useLogger } from '../../appContext/LoggerProvider';
import { StoreContext } from '../../appContext/StoreProvider';
import { MainApp } from './MainApp';
import LazyMenuEditor from '../MenuEditor/LazyMenuEditor';
import {
  logNavigationClickFromLocation,
  logSiteVisit,
  logToGoogleAnalytics,
  sendAppLoadedEvent,
} from './utils';
import { isOneOfVeloViewers } from '../../../utils';
import { isClientSide } from '../../../common/utils';
import {
  isBackOffice,
  isBranch,
  isMenuEditorPath,
  MENU_EDITOR_PATH,
  scrollToActiveElementOnMount,
} from '../../../utils/locationUtils';
import { addHashValueFromHashRedirect } from '../../../utils/locationUtils/addHashValueFromHashRedirect';
import { changeHashValuesToBePartOfTheUrl } from '../../../utils/locationUtils/changeHashValuesToBePartOfTheUrl';
import { NAV_TYPES } from '../../LoggerFactory/BiAnalyticsLogger/events/consts';

export default function App() {
  const location = useLocation();
  const history = useHistory();
  const { store } = useContext(StoreContext);
  const { logger } = useLogger();
  const [isPreview, setIsPreview] = useState(false);
  const shouldLoadWixDevelopersHeader =
    !store.viewer.isInternalViewer() &&
    !isOneOfVeloViewers(store.viewer.category) &&
    !isBackOffice(location);

  useEffect(() => {
    if (isClientSide()) {
      logSiteVisit(logger, location, store);
      sendAppLoadedEvent(logger);
    }

    changeHashValuesToBePartOfTheUrl(history, store.getFullTree());

    addHashValueFromHashRedirect(history);
    const historyUnsubscribe = history.listen((_location, action) => {
      logToGoogleAnalytics(logger, _location);

      if (shouldLogClickBiNavigation(_location)) {
        logNavigationClickFromLocation(logger, _location, store);
      }

      if (action === 'POP') {
        scrollToActiveElementOnMount(_location);
      }
    });

    if (shouldLoadWixDevelopersHeader) {
      loadWixDevelopersHeader(location, isPreview);
    }

    const cleanUp = () => {
      historyUnsubscribe();
    };

    return cleanUp;
  }, []);

  useEffect(() => {
    if (shouldLoadWixDevelopersHeader) {
      loadWixDevelopersHeader(location, isPreview);
    }
  }, [isPreview, location]);

  return (
    <Switch>
      <Route
        exact
        path={MENU_EDITOR_PATH}
        render={() => (
          <LazyMenuEditor isPreview={isPreview} setIsPreview={setIsPreview} />
        )}
      />
      <Route
        path="/"
        render={({ staticContext }) => (
          <MainApp staticContext={staticContext} isPreview={isPreview} />
        )}
      />
    </Switch>
  );
}

function loadWixDevelopersHeader(location, isPreview) {
  window.config = window.config || {};
  window.config.dev = { __BASEURL__: window.__BASEURL__ };
  require('@wix/dev-center-header/dist/statics/app.bundle.js');
  const header = document.getElementById('custom-header');
  const isMenuEditor = isMenuEditorPath(location.pathname);
  if (isBranch(location) || (isPreview && !isMenuEditor)) {
    header.classList.add('withNotificationBar');
  } else if (isMenuEditor) {
    header.classList.remove('withNotificationBar');
  }
}

function shouldLogClickBiNavigation(_location) {
  return (
    _location.state &&
    _location.state.navType &&
    _location.state.navType !== NAV_TYPES.SCROLL
  );
}
